import { Helmet } from "react-helmet-async";

const SITE = "https://havenandhillproperties.com";

export const Seo = ({ title, description, path = "/" }) => (
  <Helmet>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    <link rel="canonical" href={`${SITE}${path}`} />
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    <meta property="og:url" content={`${SITE}${path}`} />
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
  </Helmet>
);
